import { useSelector } from 'react-redux';
import classes from './AdminTabs.module.css';

const TABS = [
  { id: 'design', labelKey: 'tabDesign' },
  { id: 'settings', labelKey: 'tabSettings' },
];

const AdminTabs = ({ activeTab, onSelect }) => {
  const { texts } = useSelector(state => state.translate);

  return (
    <div className={classes.Tabs} role="tablist">
      {TABS.map(tab =>
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={activeTab === tab.id ? classes.TabActive : classes.Tab}
          onClick={() => onSelect(tab.id)}
        >
          {texts[tab.labelKey]}
        </button>
      )}
    </div>
  );
};

export default AdminTabs;
